<template>
  <div>
    <div class="card mb-4">
      <div class="card-body">
        <UsageView id="modules.automation.tasks.count"/>
      </div>
    </div>
    <CollectionView :endpoint="utilities.path('communities/@/modules/automation/rules', communityId)" searchable v-model:reload="reload" :orderable="[{key:'name', name: translate('name')}]">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("automation.rules") }}</h4>
          <ButtonView type="normal" color="primary" @click="creating = true">
            {{ translate("create") }}
          </ButtonView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("name") }}</div>
                <div class="table-header-cell">{{ translate("automation.trigger") }}</div>
                <div class="table-header-cell">{{ translate("active") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">{{ item.name }}</div>
                  <div class="table-column">
                    <i :class="item.trigger.icon" class="fa-lg"></i>
                    <span class="ms-2">{{ item.trigger.title }}</span>
                  </div>
                  <div class="table-column">
                    <i class="fas fa-lg" :class="item.active ? 'fa-check-circle text-success' : 'fa-times-circle text-warning'"></i>
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView type="soft" color="primary" size="small" @click="editId = item.id">
                        <i class="fas fa-edit"></i>
                      </ButtonView>
                      <TargetedModalHttpFormView size="small" :endpoint="utilities.path('modules/automation/rules/@', item.id)" method="delete" @success="reload = true">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click="show">
                            <i class="fas fa-trash"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:form="{ submit, loading, hide }">
                          <h2 class="mb-4">{{ item.name }}</h2>
                          <SpinnerView :active="loading" color="danger"/>
                          <div class="d-flex align-items-center g-4">
                            <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                              {{ translate("delete") }}
                            </ButtonView>
                            <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                              {{ translate("cancel") }}
                            </ButtonView>
                          </div>
                        </template>
                      </TargetedModalHttpFormView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView :active="creating || editId !== undefined">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0">{{ translate("automation_rule") }}</h3>
          <ModalCloseButtonView @click="creating = false; editId = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <HttpContentView v-if="editId" :endpoint="utilities.path('modules/automation/rules/@', editId)">
          <template v-slot:content="{ data }">
            <AutomationRuleFormView :community-id="communityId" :rule="data" @success="editId = undefined; reload = true" @cancel="editId = undefined"/>
          </template>
        </HttpContentView>
        <AutomationRuleFormView v-else :community-id="communityId" @success="creating = false; reload = true" @cancel="creating = false"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {ButtonView, CollectionView, utilities, ModalCloseButtonView, ModalView, TargetedModalHttpFormView, HttpContentView, SpinnerView} from "@/niftybit";
import {ref} from "vue";
import AutomationRuleFormView from "@/systems/modules/automation/AutomationRuleFormView.vue";
import UsageView from "@/systems/usage/UsageView.vue";

defineProps({
  communityId: String
});

const reload = ref(false);

const creating = ref(false);
const editId = utilities.routeQueryParam("editId");

</script>
